// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M18 1H6V6H9.5V8H6V11H11V13H6V16H9.5V18H6V23H18V1Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-measurement-filled')
export default class MeasurementFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'measurement-filled',
    }
  }
}
